import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { useBusinessTypeContext } from '../../contexts/BusinessTypeContext';

const GoatBreedingPlan: React.FC = () => {
  const { businessType } = useBusinessTypeContext();

  if (businessType !== 'goat') {
    return (
      <div className="container-mobile py-8 text-center">
        <p className="text-gray-600">This page is only available for goat farming locations.</p>
        <Link to="/dashboard" className="text-blue-600 hover:text-blue-800">Go to Dashboard</Link>
      </div>
    );
  }

  return (
    <div className="container-mobile py-6 space-y-6">
      {/* Header */}
      <div className="text-center">
        <CalendarIcon className="h-16 w-16 text-purple-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Breeding Plan</h1>
        <p className="text-lg text-gray-600">
          Plan and schedule breeding activities
        </p>
      </div>

      {/* Coming Soon Message */}
      <div className="card p-8 text-center">
        <div className="max-w-md mx-auto">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-purple-100 mb-4">
              <CalendarIcon className="h-10 w-10 text-purple-600" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Coming Soon</h2>
          <p className="text-gray-600 mb-6">
            We're working on building the Breeding Plan feature. This will allow you to:
          </p>
          <div className="space-y-2 text-left bg-gray-50 rounded-lg p-4">
            <p className="text-sm font-semibold text-gray-700 mb-2">Planned Features:</p>
            <ul className="space-y-1 text-sm text-gray-600">
              <li>• Schedule breeding activities</li>
              <li>• Plan breeding cycles</li>
              <li>• Track breeding schedules</li>
              <li>• Set reminders for breeding dates</li>
              <li>• View breeding calendar</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Navigation Links */}
      <div className="flex justify-center space-x-4">
        <Link
          to="/goat/logs"
          className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          Back to Goat Logs
        </Link>
        <Link
          to="/goat/dashboard"
          className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default GoatBreedingPlan;
